export default "__VITE_ASSET__BLDnvHGf__"